var _defs, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.092,
    x2: 0.908,
    y1: 0.908,
    y2: 0.092,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507,
    stopColor: "#f44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9c27b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: 0.146,
    x2: 0.854,
    y1: 0.854,
    y2: 0.146
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: 0.146,
    x2: 0.854,
    y1: 0.854,
    y2: 0.146
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M22.917 0h-12.5A10.417 10.417 0 0 0 0 10.417v12.5a10.417 10.417 0 0 0 10.417 10.416h12.5a10.417 10.417 0 0 0 10.416-10.416v-12.5A10.417 10.417 0 0 0 22.917 0Zm7.292 22.917a7.3 7.3 0 0 1-7.292 7.292h-12.5a7.3 7.3 0 0 1-7.292-7.292v-12.5a7.3 7.3 0 0 1 7.292-7.292h12.5a7.3 7.3 0 0 1 7.292 7.292Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M12.333 4a8.333 8.333 0 1 0 8.333 8.333A8.333 8.333 0 0 0 12.333 4Zm0 13.542a5.208 5.208 0 1 1 5.208-5.208 5.215 5.215 0 0 1-5.208 5.208Z",
    transform: "translate(4.333 4.333)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.11,
    cy: 1.11,
    r: 1.11,
    fill: "url(#c)",
    transform: "translate(24.515 6.598)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramGradient);
export default __webpack_public_path__ + "static/media/instagram-gradient.871e33d72cdc67fd496bd08fac13c3f8.svg";
export { ForwardRef as ReactComponent };